var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rest-form-item',{attrs:{"label":_vm.$t('ChannelConfig_SmsStudio_Token'),"prop":"token"}},[_c('el-input',{attrs:{"placeholder":_vm.$t('ChannelConfig_SmsStudio_Token_Placeholder')},model:{value:(_vm.model.params.token),callback:function ($$v) {_vm.$set(_vm.model.params, "token", $$v)},expression:"model.params.token"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-203a3292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/channels/providers/SmsStudio.vue
// module id = null
// module chunks = 